function updateVh() {
	// We execute the same script as before
	let vh = window.innerHeight * 0.01 - 0.001;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
}
window.addEventListener('resize', updateVh);
updateVh()